
/* eslint-disable */
export default {
  props: ["promos", "promoSize", "className"],
  created() { },
};
